import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { MinimalUserProfileFragment } from 'api';

import UserAvatar from './UserAvatar';

interface Props {
  users: MinimalUserProfileFragment[];
}

const useStyles = makeStyles(theme => ({
  avatarGroup: {
    display: 'flex',
    '&:first-child': {
      marginLeft: theme.spacing(0),
    },
  },
  avatar: {
    marginLeft: theme.spacing(-1),
  },
}));

const UserAvatarGroup: FC<Props> = ({ users }) => {
  const classes = useStyles();

  if (!users.length) {
    return null;
  }

  return (
    <div className={classes.avatarGroup}>
      {users.map(user => (
        <UserAvatar size={40} className={classes.avatar} key={user.id} user={user} />
      ))}
    </div>
  );
};

export default UserAvatarGroup;
